import React from "react";
import { render } from "react-dom";

import { JobsBanner } from "@themuse/muse-front-end/dist/components/jobs_banner/component";
import { getTrackingPropsAsDataAttrs, pushDataLayerEvent } from "@util/tracking";
import Axios from "axios";

const getDMAFromCarmenAPI = async () => {
    // DMA: Designated Market Area
    const { data } = await Axios.get("https://carmen.themuse.com/me");
    return data.dma;
};

const translateDMAString = (dma: string) => {
    // Some DMA strings need to be translated from their original string to a simpler string for display purposes.
    const dmaDisplayTranslations: { [key: string]: string } = {
        "San Francisco-Oakland-San Jose, CA": "San Francisco, CA",
        "Boston, MA-Manchester, NH": "Boston, MA",
        "Washington, DC (Hagerstown, MD)": "Washington, DC",
        "Seattle-Tacoma, WA": "Seattle, WA"
    };
    return dmaDisplayTranslations[dma] || dma;
};

const getWhiteListedLocationFromDMA = (dma: string) => {
    const whitelistedDMAs = [
        "New York, NY",
        "San Francisco, CA",
        "Chicago, IL",
        "Boston, MA",
        "Washington, DC",
        "Austin, TX",
        "Denver, CO",
        "Seattle, WA",
        "Los Angeles, CA"
    ];

    return whitelistedDMAs.includes(dma) ? dma : null;
};

const getBannerType = () => {
    const jobsBannerMobileMaxWidth = 767;
    const jobsBannerTabletMaxWidth = 1129;
    const windowWidth = window.innerWidth;

    if (windowWidth <= jobsBannerMobileMaxWidth) {
        return "mobile banner bottom";
    }
    if (windowWidth <= jobsBannerTabletMaxWidth) {
        return "tablet bottom banner";
    }
    return "desktop right rail";
};

export const initJobsSidebar = async () => {
    const jobsSidebarElement = document.querySelector(".js-jobs-sidebar");
    const dma = await getDMAFromCarmenAPI();
    const location = getWhiteListedLocationFromDMA(translateDMAString(dma));
    const bannerType = getBannerType();

    if (jobsSidebarElement) {
        const trackingProps = {
            clickEvent: "adviceJobsBannerClicked",
            viewEvent: "adviceJobsBannerViewed",
            eventProps: {
                banner_type: bannerType,
                source: "post-individual",
                dma_location: dma,
                used_location: location
            }
        };
        const dataProps = getTrackingPropsAsDataAttrs(trackingProps);
        const { oskarClick, oskarView, oskarProps } = dataProps;

        jobsSidebarElement.setAttribute("data-oskar-click", oskarClick);
        jobsSidebarElement.setAttribute("data-oskar-view", oskarView);
        jobsSidebarElement.setAttribute("data-oskar-props", oskarProps);

        render(<JobsBanner location={location} />, jobsSidebarElement, () => {
            pushDataLayerEvent("adviceJobsBannerLoaded", trackingProps.eventProps);
        });
    }
};
